<template>
  <div>
    <KPIAdd />
  </div>
</template>

<script>
import KPIAdd from "./KPIAdd.vue";

export default {
  components: {
    KPIAdd,
  },

  data() {
    return {};
  },
};
</script>
